import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    Autocomplete,
    Box,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import CustomDepartmentSelect from './CustomDepartmentSelect';



import MyDatePicker from '../../components/Date-range-picker/MyDatePicker';

const labelStyle = {
    marginBottom: '4px',
    fontWeight: 600,
    color: '#1A1A1A',
    fontSize: '14px',
};

const inputStyle = {
    height: '46px',
    backgroundColor: '#fff',
    fontSize: '13px',
};


const Employment = ({ onCancel, onSave }) => {

    const jobTitleOptions = [
        'Marketing Coordinator ', 'Medical Assistant', 'Trainer', 'President of Sales'
    ]

    const jobTypeOptions = [
        'Admin / HR ', 'Catalog manager', 'Content quality analyst', 'Customer success', 'Digital marketing specialist',
    ]
    const departmentOptions = [
        'Marketing Coordinator ', 'Medical Assistant', 'Trainer', 'President of Sales'
    ]
    const employmentTypeOptions = [
        'Contractor - hourly', 'Contractor - fixed rate', 'Contractor - project based', 'FTE - hourly (full-time employee)', 'FTE - salary (full-time employee)'
    ]
    const eployedThroughOptions = [
        'Direct - hired by us', 'Vendor', 'EOR', 'Subsidiary',
    ]
    const InOfficeRemoteOptions = [
        'In-office', 'Remote', 'Hybrid',
    ]
    const InOfficeOptions = [
        '100 %', '95 %', '90 %', '85 %', '80 %', '75 %', '70 %', '65 %', '60 %', '55 %', '50 %', '45 %', '40 %', '35 %', '30 %', '25 %', '20 %', '15 %', '10 %', '05 %', '0 %',
    ]
    const remoteOptions = [
        '100 %', '95 %', '90 %', '85 %', '80 %', '75 %', '70 %', '65 %', '60 %', '55 %', '50 %', '45 %', '40 %', '35 %', '30 %', '25 %', '20 %', '15 %', '10 %', '05 %', '0 %',
    ]
    const TerminationReasonOptions = [
        'Voluntary', 'Involuntary', 'Contract ended',
    ]


    return (
        <form>

            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#64748B', }}>Job Details</Typography>
                </Grid>
                {/* Jon Title */}
                <Grid item size={{ xs: 12, md: 4, sm: 7 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Job Title
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select Job Title" modalSearchplaceHolder="Search Job Title" showAddOption={true} initialOptions={jobTitleOptions} addButtonLabel="+ Add Job Title"
                        modalTitle="Add Job Title"
                        modalSubTitle="This will update selection choices in all member profiles"
                        modalInputTitle="Job Title"
                        modalPlaceholder="Enter a Job title" />
                </Grid>
                {/* Job Type */}
                <Grid item size={{ xs: 12, md: 4, sm: 5 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Job Type
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select Job Type" modalSearchplaceHolder="Search Job Type" initialOptions={jobTypeOptions} showAddOption={false} />
                </Grid>
                {/* Department */}
                <Grid item size={{ xs: 12, md: 4, sm: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Department
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select Department" modalSearchplaceHolder="Search Department" modalInputTitle="Department" modalPlaceholder="Enter a Department " initialOptions={departmentOptions} showAddOption={true} />
                </Grid>

                {/* Department */}
                <Grid item size={{ xs: 12, md: 12, sm: 12 }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#64748B' }}>Hiring Details</Typography>
                </Grid>

                <Grid item size={{ xs: 12, md: 12, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Employment type
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Employment type" modalSearchplaceHolder="Search Employment type" showAddOption={false} initialOptions={employmentTypeOptions} />
                </Grid>
                {/* Employed through */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Employed through
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Employed through" modalSearchplaceHolder="Search Employed through" showAddOption={false} initialOptions={eployedThroughOptions} />
                </Grid>

                {/*  Name of Vendor */}
                <Grid item size={{ xs: 12, md: 6, sm: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Name of Vendor
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Name of Vendor"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                {/* Employed through */}
                <Grid item size={{ xs: 12, md: 4, sm: 7 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        In-office / Remote
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="In-office" modalSearchplaceHolder="Search In-office" showAddOption={false} initialOptions={InOfficeRemoteOptions} />
                </Grid>
                <Grid item size={{ xs: 12, md: 4, sm: 5 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        % In-office
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="%" modalSearchplaceHolder="Search %" showAddOption={false} initialOptions={InOfficeOptions} />
                </Grid>
                <Grid item size={{ xs: 12, md: 4, sm: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        % Remote
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select %" modalSearchplaceHolder="Search %" showAddOption={false} initialOptions={remoteOptions} />
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#64748B', }}>Timeline</Typography>
                </Grid>
                {/* Start Date */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Start Date
                    </Typography>
                    <MyDatePicker />
                </Grid>

                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={{ ...labelStyle, display: 'flex', justifyContent: 'space-between', }}>
                        End Date  <Button sx={{ fontSize: '12px', color: '#0076FE', textTransform: 'capitalize', py: 0 }}>Begin offboarding</Button>
                    </Typography>
                    <MyDatePicker />
                </Grid>

                <Grid item size={{ xs: 12, md: 12, sm: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Termination Reason
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select Termination Reason" modalSearchplaceHolder="Search Termination Reason" showAddOption={false} initialOptions={TerminationReasonOptions} />
                </Grid>
                <Grid item size={{ xs: 12, md: 12, sm: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Employment Comments
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Employment Comments"
                        variant="outlined"
                        sx={{
                            '& .MuiInputBase-root': {
                                fontSize: '13px',
                            },
                            '& textarea': {
                                fontSize: '13px',
                            },
                            '& textarea::placeholder': {
                                fontSize: '13px !important',
                                color: '#999',
                                opacity: 1,
                            },
                        }}
                    />
                </Grid>

                {/* Action Buttons */}
                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#fff',
                            border: '1px solid #9095A1',
                            color: '#9095A1',
                        }}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        }}
                        onClick={onSave}
                    >
                        Save & Update
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default Employment;
